module.exports = __webpack_public_path__ + "static/kmy-296bdcee8b726e070ce0aa90dc4a8640.png";